import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import {
  withToolsSiteMap,
  siteMapPropType,
  processorSet,
} from '@bingads-webui-campaign-react/with-site-map';
import { PageMenu } from '@bingads-webui-campaign-react/page-menu';

const businessDataPageGroups = [
  ['ad-customizer-feeds'],
  ['dynamic-data-feeds'],
  ['page-feeds'],
  ['customizer-attributes'],
];
export const Loader = (props) => {
  const { siteMap, updateAvailability } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });

  useEffect(() => {
    updateAvailability(!_.isEmpty(selectedParent));
  });
  return props.isVisible ? (<PageMenu pageGroups={businessDataPageGroups} shouldRenderParentNodeAsLink={false} {...props} />) : null;
};

Loader.propTypes = {
  siteMap: siteMapPropType.isRequired,
  updateAvailability: PropTypes.func,
  isVisible: PropTypes.bool,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
  isVisible: false,
};

export const BusinessDataPageMenuLoader = withToolsSiteMap(
  React.memo(Loader),
  processorSet.all,
  _.flatten(businessDataPageGroups)
);
